import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Menu, Icon } from "capitalrx-components-2.0/lib/general";

import { ThemedMenuButton } from "../themed";
import styled from "styled-components";

const TranslationMenuButton = styled(ThemedMenuButton)`
  * {
    text-transform: none;
    font-weight: normal;
    letter-spacing: 0 !important;
    color: #313e48;
  }

  path {
    fill: #313e48 !important;
  }
`;

export const LanguageSwitcher: FC = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (language: string): void => {
    i18n.changeLanguage(language);
  };

  const currentLanguageLabel = i18n.language === "es" ? "Español" : "English";

  return (
    <TranslationMenuButton
      label={
        <>
          <Icon color={{ r: 49, g: 62, b: 72, alpha: 255 }} name={"globe"} />
          {currentLanguageLabel}
        </>
      }
      appearance="text"
    >
      {currentLanguageLabel == "Español" && (
        <Menu.Item onClick={() => handleLanguageChange("en")} key="english-language">
          <>
            English
          </>
        </Menu.Item>
      )}
      {currentLanguageLabel == "English" && (
        <Menu.Item onClick={() => handleLanguageChange("es")} key="spanish-language">
          <>
            Español
          </>
        </Menu.Item>
      )}
    </TranslationMenuButton>
  );
};
